import { render, staticRenderFns } from "./ItemAuthorDiscardDialog.vue?vue&type=template&id=c0d514f2&scoped=true"
import script from "./ItemAuthorDiscardDialog.vue?vue&type=script&lang=ts"
export * from "./ItemAuthorDiscardDialog.vue?vue&type=script&lang=ts"
import style0 from "./ItemAuthorDiscardDialog.vue?vue&type=style&index=0&id=c0d514f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d514f2",
  null
  
)

export default component.exports